import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";

// Get Table Data
export const SecurityTableDataAPI = createAsyncThunk("SecurityTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_TTP_PumpStationID,
        M_WS_PumpStationID,
        M_UserID,
        token,
        From,
        To,
        DashProjectTypeId,
        handleGetPDFUrl,
        RoleID,
        Flag,
        handleSecurityExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterSecurity_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_PumpStationID=${M_WS_PumpStationID ? M_WS_PumpStationID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`
    }else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_T_TTP_WaterSecurity_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_TTP_PumpStationID=${M_TTP_PumpStationID ? M_TTP_PumpStationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_Security_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_PumpStationID=${M_WS_PumpStationID ? M_WS_PumpStationID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleSecurityExport && handleSecurityExport()
                handleGetPDFUrl(result.url)
                return result.data
            } else {
                return result
            }
        })
})

const SecurityTableDataSlice = createSlice({
    name: "SecurityTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SecurityTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(SecurityTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(SecurityTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const SecurityTableDataReducer = SecurityTableDataSlice.reducer


export const SecurityTableExportDataAPI = createAsyncThunk("SecurityTableExportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_TTP_PumpStationID,
        M_WS_PumpStationID,
        M_UserID,
        token,
        From,
        To,
        DashProjectTypeId,
        handleGetPDFUrl,
        RoleID,
        Flag
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterSecurity_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_PumpStationID=${M_WS_PumpStationID ? M_WS_PumpStationID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`
    }else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_T_TTP_WaterSecurity_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_TTP_PumpStationID=${M_TTP_PumpStationID ? M_TTP_PumpStationID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_Security_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_PumpStationID=${M_WS_PumpStationID ? M_WS_PumpStationID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleGetPDFUrl(result.url)
                return result.data
            } else {
                return result
            }
        })
})

const SecurityTableExportDataSlice = createSlice({
    name: "SecurityTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SecurityTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(SecurityTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(SecurityTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const SecurityTableExportDataReducer = SecurityTableExportDataSlice.reducer

// -----------------Delete API ---------------

export const SecurityDeleteAPI = createAsyncThunk("SecurityDelete", async ({ data }) => {
    const {
        T_TTP_WaterSecurityID,
        T_WS_SecurityID,
        T_Distri_WaterSecurityID,
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    // var formdata = new FormData();
    // formdata.append("T_WS_SecurityID", T_WS_SecurityID);
    // formdata.append("M_UserID", M_UserID);

    var formdata = new FormData();
    
    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterSecurityID", T_Distri_WaterSecurityID);
    }else if (DashProjectTypeId == '9') {
        formdata.append("T_TTP_WaterSecurityID", T_TTP_WaterSecurityID);
    }else {
        formdata.append("T_WS_SecurityID", T_WS_SecurityID);
    }
    formdata.append("M_UserID", M_UserID);
    
    var requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_WaterSecurity_Delete`
    } else if (DashProjectTypeId == '9') {
        url = `${BaseUrl}/APKDashboard/WEB_T_TTP_WaterSecurity_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_Security_Delete`
    }
    
    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const SecurityDeleteSlice = createSlice({
    name: "SecurityDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SecurityDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(SecurityDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(SecurityDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const SecurityDeleteReducer = SecurityDeleteSlice.reducer